import React, { useEffect, useState } from "react";
import { Button, Drawer } from "antd";
import BrandCards, { BrandOption } from "./BrandCards";
import SheetHeaderClose from "./SheetHeaderClose";

interface Props {
  open: boolean;
  onClose: () => void;
  brands: BrandOption[];
  value: string[];
  onApply: (value: string[]) => void;
}

export default function BrandPickerSheet({ open, onClose, brands, value, onApply }: Props) {
  const [draft, setDraft] = useState<string[]>(value);

  useEffect(() => {
    if (open) setDraft(value);
  }, [open, value]);

  const apply = () => {
    onApply(draft);
    onClose();
  };

  return (
    <Drawer
      open={open}
      onClose={onClose}
      placement="bottom"
      height="auto"
      title="Brands"
      closable={false}
      extra={<SheetHeaderClose onClose={onClose} />}
      rootClassName="v2-sheet v2-sheet--brands"
      footer={
        <div className="v2-filters__footer">
          <Button type="text" className="v2-filters__clear" onClick={() => setDraft([])}>
            Clear All
          </Button>
          <Button type="primary" className="v2-filters__apply" onClick={apply}>
            Apply
          </Button>
        </div>
      }
    >
      <p className="v2-sheet__lede">Please choose your preferred brands.</p>
      <BrandCards
        brands={brands}
        selected={draft}
        onToggle={(brand) =>
          setDraft(draft.includes(brand) ? draft.filter((item) => item !== brand) : [...draft, brand])
        }
      />
    </Drawer>
  );
}
